import template from './reports.pug';

/* @ngInject */
export default function routes($stateProvider) {
  $stateProvider
    .state('main.reports', {
      abstract: true,
      url: '/reports',
      template,
      data: { pageTitle: 'Reports | EBGC' },
    });
}



// WEBPACK FOOTER //
// ./client/app/reports/reports.routes.js